import map from "lodash/fp/map";
import constants from "../../core/constants";
import moment from "moment";

class TicketsPageTransform {
  constructor() {
    "ngInject";

    this.fields = [
      { title: "Type", name: "title" },
      { title: "Date", name: "createdAt" },
      { title: "status", name: "status" },
    ];
  }

  justify(data) {
    const format = (item) => {
      item.createdAt = moment(item.createdAt).format(constants.dateTimeFormat);
      item.status = { ticketStatus: item.status };

      return item;
    };

    return map(format)(data);
  }
}

export default TicketsPageTransform;



// WEBPACK FOOTER //
// ./src/pages/tickets/tickets.transforms.js